import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    return {
        methods: {
            localEditor: {
                save: publicMethodUtils.extensionPublicAPI.immediate('localEditor.save'),
                fullSave: publicMethodUtils.extensionPublicAPI.immediate('localEditor.fullSave'),
                documentFixesApplied: publicMethodUtils.extensionPublicAPI.immediate('localEditor.documentFixesApplied')
            }
        }
    }
}
